// extracted by mini-css-extract-plugin
module.exports = {"container":"Routes_container__2iYcG"};